import React, { Component } from "react";

import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import FamilyService from "../services/family.service";
import AuthService from "../services/auth.service";

export default class BoardFamily extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: "",
      expenses: [],
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
    };
  }

  componentDidMount() {
    UserService.getFamilyBoard().then(
      (response) => {
        this.setState({
          content: response.data,
        });
      },
      (error) => {
        this.setState({
          content:
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString(),
        });

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );

    const currentUser = AuthService.getCurrentUser();
    const selectedFamily = JSON.parse(localStorage.getItem("selectedFamily"));
    
    if (selectedFamily) {
      this.retrieveExpenses(this.state.currentYear, this.state.currentMonth, selectedFamily.id);
    } else if (currentUser && currentUser.families && currentUser.families.length > 0) {
      const family = currentUser.families[0];
      localStorage.setItem("selectedFamily", JSON.stringify(family));
      this.retrieveExpenses(this.state.currentYear, this.state.currentMonth, family.id);
    }
  }

  retrieveExpenses(year, month, familyId) {
    FamilyService.getExpensesByMonthYearFamilyId(month, year, familyId)
      .then((response) => {
        this.setState({
          expenses: response.data,
        }, () => {
          // This will be executed after the state has been updated
          console.log("Expenses updated:", this.state.expenses);
        });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    const { expenses, currentMonth, currentYear } = this.state;

    return (
      <div className="container">
        <header className="jumbotron">
          <h3>
            {this.state.content}
          </h3>
          <h3>
            Expenses for Family for {currentMonth}/{currentYear}
          </h3>
        </header>
        <ul className="list-group">
          {expenses.length > 0 ? (
            expenses.map((expense, index) => (
              <li className="list-group-item" key={index}>
                {expense.name}: {expense.note} (${expense.amount}) - Owner: {expense.owner}
              </li>
            ))
          ) : (
            <p>No expenses for this month.</p>
          )}
        </ul>
      </div>
    );
  }
}
